import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/icons/chevronRight.svg")